import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react';
import useCsrfToken from '../hooks/useCsrfToken';

export default function Postsmini() {
    const { csrfToken } = useCsrfToken();
    const [listings, setListings] = useState([]);
    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL;
        const transformData = (data) => {
            const formattedDate = new Date(data.created_at).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            return {
                id: data.id,
                image: `${API_URL}${data.primary_image}`,
                tag: 'Blog',
                name: data.title,
                date: formattedDate,
                slug: data.slug,
            };
        };
        if (csrfToken != null) {
            fetch(`${API_URL}/api/blog-recent`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    if (data.length && !data.error) {
                        const transformedListings = data.map(item => transformData(item));
                        setListings(transformedListings);
                    }

                })
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [csrfToken]);
    return (
        <>
            {listings && listings.length > 0 && (
                <div className="row">
                    <div className="mt-0">
                        <h6 className="pt-2 pb-2 bg-light rounded text-center">Publicaciones recientes</h6>
                        <div className="mt-4">
                            {listings.map((item, index) => {
                                return (
                                    <div className="blog blog-primary d-flex align-items-center mt-3" key={index}>
                                        <Link to={`/blog-leer/${item.slug}`} className="d-block">
                                            <img src={item.image} className="avatar avatar-small rounded object-fit-cover" style={{ width: 'auto' }} alt="" />
                                        </Link>
                                        <div className="flex-1 ms-3">
                                            <Link to={`/blog-leer/${item.slug}`} className="d-block title text-dark fw-medium">{item.name}</Link>
                                            <span className="text-muted small">{item.date}</span>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
